<div id="managePopUp">
    <div class="modal-header">
        <span class='modal-title' *ngIf="header">{{header}}</span>
        <button type="button" class="close" aria-label="Close" (click)="close()" *ngIf="!action">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" *ngIf="message">
        <p class="message"  [innerHtml]="message"></p>
    </div>
    <div class="modal-footer pull-right popup_btnbox bottom_aligner">
        
        <div class='btnFullWidth' *ngIf="ctaClose">
            <button type='button' class='secondary_btn'
                (click)="close()" >{{ctaClose}}</button>
        </div>
        <div class='btnFullWidth' *ngIf="ctaCancel">
            <button type='button' class='secondary_btn'
                (click)="close()">{{ctaCancel}}</button>
        </div>
        <div class='btnFullWidth' *ngIf="ctaAllow">
            <button type='button' class='primary_btn'
                (click)="onClickYes()">{{ctaAllow}}</button>
        </div>
    </div>

</div>